import { render } from "./InstagramCampaignsChart.vue?vue&type=template&id=39b2bba0&ts=true"
import script from "./InstagramCampaignsChart.vue?vue&type=script&lang=ts"
export * from "./InstagramCampaignsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__